import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';
const PlusCircleIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_1313_7891)"><path d="M11.25 6C11.25 3.14336 8.85664 0.75 6 0.75C3.14336 0.75 0.75 3.14336 0.75 6C0.75 8.85664 3.14336 11.25 6 11.25C8.85664 11.25 11.25 8.85664 11.25 6ZM5.625 8.89307V6.375H3.10693C2.89999 6.37481 2.73193 6.20699 2.73193 6C2.73194 5.79301 2.89999 5.62519 3.10693 5.625H5.625V3.10693C5.62519 2.89999 5.79301 2.73194 6 2.73193C6.20699 2.73193 6.37481 2.89999 6.375 3.10693V5.625H8.89307C9.10001 5.62519 9.26806 5.79301 9.26807 6C9.26807 6.20699 9.10001 6.37481 8.89307 6.375H6.375V8.89307C6.37481 9.10001 6.20699 9.26807 6 9.26807C5.79301 9.26806 5.62519 9.10001 5.625 8.89307ZM12 6C12 9.27086 9.27086 12 6 12C2.72914 12 0 9.27086 0 6C0 2.72914 2.72914 0 6 0C9.27086 0 12 2.72914 12 6Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PlusCircleIcon;